<template>
  <layout>
    <page-header :actions="actions" :header="$t('affiliates.title')" />
    <div class="content">
      <admin-table ref="table" v-bind="tableProps">
        <template slot="name" slot-scope="{ item }">
          <div class="media">
            <div class="media-left mr-2">
              <div class="h-10 w-10">
                <img
                  v-if="item.avatar && item.avatar.url"
                  :src="thumb(item.avatar, 60, 60, true)"
                  class="rounded-full max-w-full"
                  alt=""
                />
                <avatar
                  v-else
                  :username="item.name"
                  :size="40"
                  :custom-style="{ maxWidth: '100%', maxHeight: '100%' }"
                  :rounded="true"
                />
              </div>
            </div>
            <div class="media-body">
              {{ item.name }}
            </div>
          </div>
        </template>
      </admin-table>
    </div>
  </layout>
</template>

<script>
import { AdminTable } from 'stylemix-vue-admin'
import { create } from 'vue-modal-dialogs'
import Avatar from 'vue-avatar'
import UsersApi from '../users/UsersApi'
import AddAffiliate from './AddAffiliate'

const resourceBase = 'users'

const invoicingRoute = ({ id, deferred_payments }) => {
  if (deferred_payments) {
    return {
      name: 'affiliates.deferred_payments',
      params: { user_id: id },
    }
  }
  return {
    name: 'affiliates.payouts',
    params: { user_id: id },
  }
}

export default {
  name: 'UsersIndex',

  components: {
    AdminTable,
    Avatar,
  },

  data() {
    return {
      // Page header actions
      actions: [
        {
          id: 'create',
          text: this.$t('affiliates.add_new'),
          icon: 'icon-plus-circle2',
          onClick: () => {
            this.addAffiliate().then(result => {
              if (!result) return
              this.$refs.table.refresh()
            })
          },
        },
      ],

      // Table resource configuration
      tableProps: {
        base: resourceBase,
        apiBuilder() {
          return new UsersApi().setParameters({
            'where[affiliate]': true,
            context: 'list',
          })
        },
        columns: [
          {
            key: 'id',
            label: 'ID',
            sortable: true,
          },
          {
            key: 'name',
            label: this.$t('affiliates.name'),
          },
          {
            key: 'email',
            label: 'Email',
            sortable: true,
          },
          {
            key: 'affiliate_commission',
            label: this.$t('affiliates.commission'),
            sortable: true,
            formatter: value => (value ? `${value}%` : null),
          },
          {
            key: 'auto_billing',
            label: this.$t('affiliates.autobilling'),
            component: 'value-boolean',
          },
          {
            key: 'deferred_payments',
            label: this.$t('affiliates.deferred_payments'),
            component: 'value-boolean',
          },
        ],
        searchFields: [
          {
            component: 'text-field',
            type: 'search',
            attribute: 'query',
            placeholder: this.$t('users.search'),
          },
          {
            component: 'select-field',
            attribute: 'where[deferred_payments]',
            placeholder: this.$t('general.all'),
            options: [
              {
                label: this.$t('affiliates.deferred_payments'),
                value: true,
              },
              {
                label: this.$t('affiliates.simple_affiliates'),
                value: false,
              },
            ],
          },
        ],

        rowActions: item => {
          return [
            {
              label: this.$t('affiliates.invoicing'),
              variant: 'light',
              handler: () => {
                this.$router.push(invoicingRoute(item))
              },
            },
            'edit',
          ]
        },

        bulkActions: () => {
          return []
        },
      },
    }
  },

  created() {
    this.addAffiliate = create(AddAffiliate)
  },
}
</script>
